module.exports = __webpack_public_path__ + "static/media/icon-golf-white.bf44fa07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-golf-white.svg
// module id = ./src/assets/images/icon-golf-white.svg
// module chunks = 6